import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RowLine, SpanBlock, LabelRow, HeaderAtendi } from './style';
import { Badge, Button, Card, List, Tooltip } from 'antd';
import {
  UserOutlined,
  CopyOutlined,
  MessageOutlined,
  CalendarOutlined,
  AlertOutlined,
  BorderlessTableOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../store/ducks/atendimentos/actions';
import CardSecMobile from '../CardSecMobile';
import { Props } from './types';
import { ApplicationState } from '../../../../store';
import GetSeveridade from '../../components/GetSeveridade';
import GetStatus from '../../../../components/GetStatus';
import { maskCapitalized } from '../../../../utils/mask';
import { colorIconConversation } from '../../Utils';
import moment from 'moment';

const CardMobile: React.FC<Props> = ({ props }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const pagination = useSelector((state: ApplicationState) => state.Atendimentos.pagination);
  const loading = useSelector((state: ApplicationState) => state.Atendimentos.loading);
  const filter = useSelector((state: ApplicationState) => state.Atendimentos.filter);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  const paginationProps = {
    onChange: (pag: any) => {
      const paginationResult = {
        ...pagination,
        current: pag,
      };
      // dispatch(loadRequest(filter, cddAtivo.codCdd, inscricaoAtiva, paginationResult));
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => {
        const color = colorIconConversation(item?.urgencia);

        return (
          <List.Item>
            <Card
              title={
                <>
                  <HeaderAtendi>
                    <div>
                      <span style={{ color: color }}>#</span>
                      <span className="themeSLA title">
                        {item?.protocolo} - {item?.tipoSolicitacao}
                      </span>
                    </div>

                    <Tooltip
                      title={`Você tem ${item?.naoLidos} nova(s) mensagen(s)! Clique no botão "Ver atendimento"`}
                      className="button"
                    >
                      <Badge
                        count={item?.naoLidos}
                        color={item?.naoLidos <= 0 ? 'transparent' : '#F5222D'}
                        style={{ borderColor: 'transparent' }}
                      >
                        <Button
                          onClick={() => {
                            // setVisibleModalConversacao(true);
                          }}
                          type="ghost"
                          icon={<MailOutlined />}
                        />
                      </Badge>
                    </Tooltip>
                  </HeaderAtendi>
                  <CardSecMobile props={item} />
                </>
              }
            >
              <RowLine>
                <LabelRow className="themeSLA">
                  <BorderlessTableOutlined style={{ color: color }} /> Status
                </LabelRow>
                <GetStatus acronym={item?.status} />
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <AlertOutlined style={{ color: color }} /> Urgência
                </LabelRow>
                <GetSeveridade severity={item?.urgencia} />
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <UserOutlined style={{ color: color }} /> Parceiro
                </LabelRow>
                {
                  <SpanBlock className="themeSLA">
                    {item?.parceiro ? maskCapitalized(item.parceiro) : 'Não informado'}
                  </SpanBlock>
                }
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <UserOutlined style={{ color: color }} /> Embarcador
                </LabelRow>
                <SpanBlock className="themeSLA">
                  {item?.embarcador ? maskCapitalized(item.embarcador) : 'Não informado'}
                </SpanBlock>
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <UserOutlined style={{ color: color }} /> Atendente
                </LabelRow>
                <SpanBlock className="themeSLA">
                  {item?.atendente ? item.atendente : 'Não informado'}
                </SpanBlock>
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <CopyOutlined style={{ color: color }} /> Nota(s)
                </LabelRow>
                <SpanBlock className="themeSLA">
                  {item?.listaNf ? item.listaNf : 'Não informado'}
                </SpanBlock>
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <CalendarOutlined style={{ color: color }} /> Abertura
                </LabelRow>
                <SpanBlock className="themeSLA">
                  {item?.dhAbertura ? moment(item.dhAbertura).format('lll') : 'Não informado'}
                </SpanBlock>
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <CalendarOutlined style={{ color: color }} /> Conclusão
                </LabelRow>
                <SpanBlock className="themeSLA">
                  {item?.dhConclusao ? moment(item.dhConclusao).format('lll') : 'Em aberto'}
                </SpanBlock>
              </RowLine>

              <RowLine>
                <LabelRow className="themeSLA">
                  <MessageOutlined style={{ color: color }} /> Assunto
                </LabelRow>{' '}
                <SpanBlock className="themeSLA">
                  {item?.assunto ? item.assunto : 'Não informado'}
                </SpanBlock>
              </RowLine>
            </Card>
          </List.Item>
        );
      }}
    />
  );
};

export default CardMobile;
